/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Role } from 'utils/user-roles';
// import jwt_decode from 'jwt-decode';

// import { getAuthToken } from 'helpers/token';
import { openInNewTab } from 'utils/common-utils';
import {
  AuthState,
  IFetchUserSucceededAction,
  IForgotPasswordForm,
  IResetPasswordForm,
  IResetTempPasswordForm,
  ISignInForm,
} from './interface';

export const initialState: AuthState = {
  authUser: {
    id: '',
    entId: [],
    firstName: '',
    lastName: '',
    email: '',
    profileImgUrl: '',
    roles: [],
    bio: '',
    timezone: '',
    country: '',
    attributes: {
      category: '',
      introVideoUrl: '',
      thankVideoUrl: '',
      rateVideoUrl: '',
      accountType: 'public',
      password: '',
      currency: 'USD',
      subscriptionFee: '0.00',
      subscriptionFrequency: 'monthly',
      achievements: [],
      statistics: [],
      sponsorContent: [],
      rating: 0,
      noOfRatings: 0,
      badges: [],
      noOfSessions: 0,
      users: [],
      followersCount: 0,
      isActive: true,
      stripeAccountCompleted: false,
      stripePayoutsEnabled: false,
      stripeAccountUrl: '',
    },
    categories: [],
  },
  loading: false,
  actionLoading: false,
  stripeConnectAlertClosed: {
    isClosed: false,
    closedTime: 0,
  },
  callbackPath: '/',
};
// @TODO: Here we have to remove "any" it means we have to define exact type. Once we develop
// this part please do it need full way. After that we can remove above eslint-disable statements.
export const authSlice = createSlice({
  name: 'feature/base/auth',
  initialState,
  reducers: {
    signIn(state: AuthState, _action: PayloadAction<ISignInForm>) {
      state.loading = true;
    },
    signInSucceeded(state: AuthState, action: PayloadAction<any>) {
      state.loading = false;
      // Token is now stored in cookies via the setAuthToken function in the saga
    },
    signInFailed(state: AuthState, _action: PayloadAction<any>) {
      state.loading = initialState.loading;
      state.authUser = initialState.authUser;
      state.loading = false;
    },
    setCallbackPath(state: AuthState, action: PayloadAction<string>) {
      state.callbackPath = action.payload;
    },
    setUnAuthenticated(state: AuthState) {
      state.loading = false;
    },
    fetchUser(state: AuthState) {
      state.loading = true;
    },
    fetchUserSucceeded(state: AuthState, action: PayloadAction<IFetchUserSucceededAction>) {
      const expert = action.payload;
      state.authUser.id = expert.id || '';
      state.authUser.entId = expert.entId || [];
      state.authUser.bio = expert.bio || '';
      state.authUser.email = expert.email || '';
      state.authUser.roles = expert.roles || [];
      state.authUser.firstName = expert.firstName || '';
      state.authUser.lastName = expert.lastName || '';
      state.authUser.profileImgUrl = expert.profileImgUrl || '';
      state.authUser.attributes.accountType = expert.attributes.accountType || 'public';
      if (expert.attributes.subscriptionFee === '' || expert.attributes.subscriptionFee === 'NaN') {
        state.authUser.attributes.subscriptionFee = '0.00';
      } else {
        state.authUser.attributes.subscriptionFee = expert.attributes.subscriptionFee;
      }
      state.authUser.attributes.subscriptionFrequency = expert.attributes.subscriptionFrequency || 'monthly';
      state.authUser.attributes.password = expert.attributes.password || '';
      state.authUser.attributes.category = expert.attributes.category || '';
      state.authUser.attributes.currency = expert.attributes.currency || 'USD';
      state.authUser.attributes.introVideoUrl = expert.attributes.introVideoUrl || '';
      state.authUser.attributes.thankVideoUrl = expert.attributes.thankVideoUrl || '';
      state.authUser.attributes.rateVideoUrl = expert.attributes.rateVideoUrl || '';
      state.authUser.attributes.achievements = expert.attributes.achievements || [];
      state.authUser.attributes.statistics = expert.attributes.statistics || [];
      state.authUser.attributes.sponsorContent = expert.attributes.sponsorContent || [];
      state.authUser.attributes.rating = expert.attributes.rating || 0;
      state.authUser.attributes.noOfRatings = expert.attributes.noOfRatings || 0;
      state.authUser.attributes.users = expert.attributes.users || [];
      state.authUser.attributes.followersCount = expert.attributes.followersCount;
      state.authUser.attributes.noOfSessions = expert.attributes.noOfSessions;
      state.authUser.attributes.isActive = expert?.attributes?.isActive !== false;
      state.authUser.attributes.stripeAccountCompleted = Boolean(
        expert.attributes.stripeAccountCompleted,
      );
      state.authUser.attributes.stripePayoutsEnabled = Boolean(
        expert.attributes.stripePayoutsEnabled,
      );

      if (expert.attributes.badges) {
        state.authUser.attributes.badges = expert.attributes.badges.filter(
          (b) => b?.badgeTitle !== undefined && b?.badgeTitle !== '',
        );
      } else {
        state.authUser.attributes.badges = [];
      }
      state.authUser.categories = expert.categories;
      state.loading = false;
    },
    fetchUserFailed(state: AuthState, _action: PayloadAction<string>) {
      state.loading = false;
    },
    signOut(state: AuthState) {
      state.loading = true;
    },
    signOutSucceeded(state: AuthState) {
      state.loading = initialState.loading;
      state.authUser = initialState.authUser;
      window.location.href = '/login';
    },
    signOutFailed(state: AuthState, _action: PayloadAction<string>) {
      state.loading = false;
    },
    getCode(state: AuthState, _action: PayloadAction<IForgotPasswordForm>) {
      state.loading = true;
    },
    getCodeSucceeded(state: AuthState) {
      state.loading = false;
    },
    getCodeFailed(state: AuthState, _action: PayloadAction<any>) {
      state.loading = false;
    },

    resetPassword(state: AuthState, _action: PayloadAction<IResetPasswordForm>) {
      state.loading = true;
    },
    resetPasswordSucceeded(state: AuthState, _action: PayloadAction<any>) {
      state.loading = false;
    },
    resetPasswordFailed(state: AuthState, _action: PayloadAction<any>) {
      state.loading = false;
    },
    resetTempPassword(state: AuthState, _action: PayloadAction<IResetTempPasswordForm>) {
      state.loading = true;
    },
    resetTempPasswordSucceeded(state: AuthState, action: PayloadAction<any>) {
      state.loading = false;
      // Token is now stored in cookies via the setAuthToken function in the saga
    },
    resetTempPasswordFailed(state: AuthState, _action: PayloadAction<any>) {
      state.loading = false;
    },
    generateConnectUrl(state: AuthState, _action: PayloadAction<{ resolve: any, reject: any }>) {
      state.actionLoading = true;
    },
    generateConnectUrlSucceeded(state: AuthState, action: PayloadAction<{ url: string }>) {
      state.actionLoading = false;
      state.authUser.attributes.stripeAccountUrl = action.payload.url;
    },
    generateConnectUrlFailed(state: AuthState) {
      state.actionLoading = false;
    },
    generateDashboardUrl(state: AuthState, _action: PayloadAction<{ resolve: any, reject: any }>) {
      state.actionLoading = true;
    },
    generateDashboardUrlSucceeded(state: AuthState) {
      state.actionLoading = false;
    },
    generateDashboardUrlFailed(state: AuthState) {
      state.actionLoading = false;
    },
    openStripeAccountLink(state: AuthState) {
      openInNewTab(state.authUser.attributes.stripeAccountUrl);
    },
    setStripeConnectAlertOpen(state: AuthState) {
      state.stripeConnectAlertClosed.isClosed = false;
    },
    setStripeConnectAlertClose(state: AuthState) {
      state.stripeConnectAlertClosed = {
        isClosed: true,
        closedTime: new Date().getTime(),
      };
    },
  },
});

export const { actions: authSliceActions } = authSlice;
